export default "__VITE_ASSET__B7jZ_5lQ__"